// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__7QK4j","header":"Messages_header__1Iwbs"};